export default __webpack_public_path__ + "static/media/pxec01-EDM.69fd88b5.png";